<template>
  <div class="swiper">
    <swiper ref="headerSwiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) of getSwiperArr" :key="index">
        <van-row class="tab-warpper">
          <van-col span="6" v-for="(itemList, index) of item" :key="index" :class="{ active:itemList.pageCode===pageCode }" @click="tabClick(itemList)"><span>{{itemList.pageName}}</span></van-col>
        </van-row>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { getUserPageCode } from '@/utils/auth'
export default {
  name: 'headerSwiper',
  data () {
    return {
      swiperOption: {
        pagination: '.swiper-pagination'
      },
      pageCode: '',
      getSwiper: [],
      getSwiperArr: Array // 构建数组
    }
  },
  props: {
    swiperList: {
      type: Array,
      require: true
    }
  },
  watch: {
    swiperList () {
      this.formatSwiper()
    }
  },
  methods: {
    // swiper整形
    formatSwiper () {
      if (this.swiperList.length === 0) { return }
      this.getSwiper = this.swiperList.concat()
      this.getSwiper.sort((a, b) => a.pageCode - b.pageCode)
      let selectedData = this.getIndexId() === false ? this.getSwiper[0] : this.getIndexId()
      this.indexId = selectedData.indexId
      this.pageCode = selectedData.pageCode
      this.swiperListChange()
    },
    // 滑动到相应的swiper高亮的位置
    swiperMoveToSlide (index) {
      this.$refs.headerSwiper.swiper.slideTo(index, 200, false) // 切换到对应的slide，速度为1秒
    },
    swiperListChange () {
      // swiper渲染 冒泡方法，添加数据
      var numArr = 0
      var NunArrGetSwiper = []
      let moveIndex = 0
      for (var i = 0; this.getSwiper.length > i; i++) {
        if (i % 4 === 0) {
          if (i !== 0) {
            numArr++
          }
          NunArrGetSwiper[numArr] = []
        }
        if (this.getSwiper[i].pageCode === this.pageCode) {
          moveIndex = numArr // 获取对应滑动到对应位置的下标
        }
        NunArrGetSwiper[numArr].push(this.getSwiper[i])
      }
      this.getSwiperArr = NunArrGetSwiper
      setTimeout(() => { //
        this.swiperMoveToSlide(moveIndex) // 执行滑动到对应下标的位置
      }, 200)
    },
    // tab点击
    tabClick (item) {
      if (item.pageCode !== this.pageCode) {
        this.pageCode = item.pageCode
        this.$emit('changePageCode', item)
      }
    },
    getIndexId () {
      for (let i = 0; i < this.getSwiper.length; i++) {
        if (getUserPageCode() === this.getSwiper[i].pageCode) {
          return this.getSwiper[i]
        }
      }
      return false
    }
  },
  created () {
    this.formatSwiper()
  }
}
</script>

<style lang="stylus" scoped>
  >>>.swiper-slide {
    display: flex;
    align-items: center;
  }
  >>>.swiper-slide.swiper-slide-active{
    display: flex;
  }
  >>>.swiper-slide.swiper-slide-next{
    display: flex
  }
  .swiper>>>.swiper-container-horizontal > .swiper-pagination-bullets{
    bottom:2px;
  }
  .swiper>>>.swiper-pagination-bullet-active{
    background:rgba(51,153,255,1);
  }
  .swiper>>>.swiper-container{
    height :100%;
    width : 100%
  }
  .swiper>>>.swiper-wrapper{
    align-items : center;
    height: 85%;
  }
  .swiper{
    background: #fff;
    display: flex;
    width: 100%;
    min-height:.48rem;
    height: 0.6rem;
    position: fixed;
    z-index: 222;
    box-shadow: 0px 0px 3px #ddd;
  }
  .swiperlist{
    position : relative;
    overflow : hidden;
    flex : 1;
  }
  .swiperlist p{
    padding-top : .02rem;
    // padding-left : .1rem;
    font-size : .13rem;
    font-weight:500;
    line-height: 1.3;
    // max-width: 68%;

  }
  .tab-warpper {
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: center;
    .van-col {
      text-align: center;
      color: #333
      span {
        font-size: .16rem;
        line-height: 2;
        font-weight: 400;
        display: inline-block;
        padding: 0 6px;
      }
    }
    .active {
      color: #008AFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/common/commonHeader.vue